import { createFileRoute } from '@tanstack/react-router'

import { ActiveDrive } from '@/features/drives/active-drive'
import { handoverGate } from '@/features/handover/gate'

/** A walk-in in progress, at `/drives/{id}/active`: the booking's own screen, by the drive's id. */
export const Route = createFileRoute('/_app/drives/$driveId_/active')({
  ...handoverGate(),
  component: ActiveDrive,
})
